"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElasticSchema = void 0;
const yup = __importStar(require("yup"));
const elasticAttributes_1 = require("../attributes/elasticAttributes");
const ea = __importStar(require("../attributes/elasticAttributes"));
const shared = __importStar(require("./sharedSchemas"));
const types_1 = require("../types");
const utils_1 = require("./utils");
exports.ElasticSchema = yup
    .object({
    productType: shared.productTypeSchema(types_1.ProductTypes.Elastic),
    sellingUnit: utils_1.reqSelectOneSchema(Object.values(elasticAttributes_1.SellingUnit)),
    widthIn: yup
        .number()
        .positive()
        .transform(utils_1.NaNtoUndefined)
        .test(utils_1.decimalsTest(6))
        .max(20)
        .required(),
    lengthM: shared.widthLengthBaseSchema.max(200).required(),
    elasticLengthType: utils_1.reqSelectOneSchema(Object.values(ea.KnownOrEstimated)),
    elasticType: shared.titleSetLargeSchema.required(),
    preSewnType: yup
        .array(shared.titleSetLargeSchema)
        .default([])
        .max(3)
        .optional(),
    qualities: yup
        .array(shared.titleSetLargeSchema)
        .default([])
        .max(3)
        .optional(),
    colour: shared.colourSchema,
    colourTone: shared.colourToneSchema,
    imperfections: shared.imperfectionsSchema.transform((val) => {
        if (val[0] instanceof Array)
            return val[0];
        return val;
    }),
    quantity: shared.quantitySchema.required(),
    packSize: shared.packSizeSchema,
    price: shared.priceSchema
})
    .when('$product.sellingUnit', (sellingUnit, schema) => {
    switch (sellingUnit) {
        case ea.SellingUnit['By Meter']:
            return schema.omit(['lengthM', 'packSize', 'elasticLengthType']);
        case ea.SellingUnit.Bundle:
            return schema.omit(['packSize', 'elasticLengthType']);
        case ea.SellingUnit['Pack']:
            return schema.omit(['elasticLengthType']);
        case ea.SellingUnit.Roll:
            return schema.omit(['packSize']);
        default:
            return schema;
    }
})
    .test('Context Check', "Product Validator needs product in it's context", (_, context) => {
    var _a;
    if (!((_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product))
        return false;
    return true;
})
    .required();
//# sourceMappingURL=elasticSchema.js.map